import api from './api';

export type ResearchType =
  | 'competitor'
  | 'market_edp'
  | 'niche_data'
  | 'pain'
  | 'trigger'
  | 'cold_call'
  | 'deep_company'
  | 'gtm_thinker';

export interface RunResearchInput {
  type: ResearchType;
  input: string;
  icpId?: string;
  personaId?: string;
}

export interface ResearchResult {
  type: ResearchType;
  title: string;
  content: string;
  provider: string;
  model: string;
  documentId?: string;
}

class ResearchService {
  async run(input: RunResearchInput): Promise<ResearchResult> {
    const response = await api.post('/research/run', input);
    return response.data;
  }
}

const researchService = new ResearchService();
export default researchService;
